import React, { useState, useEffect, useRef } from "react";
import {
  InputGroup,
  InputGroupAddon,
  Input,
  InputGroupText,
  Table,
  Button,
  Badge,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
// import classnames from 'classnames';
import "./Components.css";
// import { ButtonToggle } from "reactstrap";
import Problems from "./Problems";

export default function Packaging(props) {
  const [input, setInput] = useState('');
  const [packedSumUp, setPackedSumUp] = useState(0)
  const [packagingList, setPackagingList] = useState([]);
  const [packedList, setPackedList] = useState([]);
  const [DesigredList, setDesigredList] = useState([]);
  const [desksList, setdesksList] = useState([]);
  // const [invoiceIdMP, setInvoiceIdMP] = useState(0);
  const [manualPrint, setManualPrint] = useState([]);
  const invoiceIdMP = useRef(0);
  const [BearbeitenType, setBearbeitenType] = useState();
  // const [documentList, setDocumentList] = useState([]);
  const [packlisteproblemInvoiceId, setPacklisteProblemInvoiceId] = useState(0);
  const [packlisteProblemtextareaValue, setpacklisteProblemtextareaValue] =
    useState();
  const [bearbeitenataForModal, setbearbeitenataForModal] = useState([]);
  const [customerInfo, setCustomerInfo] = useState();
  // const [rechnung, setRechnung] = useState();
  // const [clickType, setclickType] = useState();
  const [imageSrc, setimageSrc] = useState();
  const [updateTriger, setUpdateTriger] = useState(false);
  // const [rechnungValue, setRechnungValue] = useState();
  const [orderID, setOrderID] = useState(0);
  const [invoiceIdForUPS, setInvoiceIdForUPS] = useState(0);
  // const [InvoiceIDTEMPORARY, setInvoiceIDTEMPORARY] = useState(0);
  const [bbId, setBbId] = useState(0);
  //   start of Modal realated states and function (REACTSTRAP)
  const {
    // buttonLabel,
    className,
  } = props;

  // const [modal, setModal] = useState(false);
  // const toggle = () => setModal(!modal);
  // let bbId2 = "0";
  const [modal3, setModal3] = useState(false);
  const toggle3 = () => setModal3(!modal3);

  const [bmodal, setbModal] = useState(false);
  const btoggle = () => setbModal(!bmodal);
  const closeBtn = (
    <button className="close" onClick={btoggle}>
      &times;
    </button>
  );

  const [nestedModal, setNestedModal] = useState(false);
  const toggleNested = (imgSrc) => {
    setNestedModal(!nestedModal);
    setimageSrc(imgSrc);
  };
  //start of dropdown realated states and function
  const [packingdropdownOpen, setPackingDropdownOpen] = useState(false);
  const packingdropdowntoggle = () =>
    setPackingDropdownOpen((prevState) => !prevState);
  const [packingdropdownValue, setPackingDropdownValue] = useState("select");
  //end of dropdown realated states and function

  // const selectedTableHandler =(numberOfTable) => {
  //     const promise1 = new Promise(() => {
  //         setPackingDropdownValue("printer")
  //     });
  //     promise1.then(() => {
  //         console.log(packingdropdownValue)
  //     })
  //     setPackingDropdownValue(`printer${numberOfTable}`);
  //     setPackingDropdownValue(packingdropdownValue)
  //     console.log(packingdropdownValue)
  //     cookieHandler(1);
  // }

  //Manual print modal
  const [MPmodal, setMPModal] = useState(false);
  const MPtoggle = () => setMPModal(!MPmodal);

  const cookieHandler = (exdays) => {
    if (packingdropdownValue !== "select") {
      const d = new Date();
      d.setTime(d.getTime() + exdays * 10 * 60 * 60 * 1000);
      let expires = "expires=" + d.toUTCString();
      document.cookie =
        "nameOfTable=" + packingdropdownValue + ";" + expires + ";path=/";
      // window.location.reload(false);
    }
  };
  useEffect(() => {
    //eslint-disable-next-line react-hooks/exhaustive-deps
    cookieHandler(1);
    //eslint-disable-next-line
    setCookieValue(
      document.cookie.replace(
        /(?:(?:^|.*;\s*)nameOfTable\s*\=\s*([^;]*).*$)|^.*$/,
        "$1"
      )
    );
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [packingdropdownValue]);
  // document.cookie = `nameOfTable=${packingdropdownValue}`
  //eslint-disable-next-line
  const [cookieValue, setCookieValue] = useState(
    document.cookie.replace(
      /(?:(?:^|.*;\s*)nameOfTable\s*\=\s*([^;]*).*$)|^.*$/,
      "$1"
    )
  );

  // let cookieValue = document.cookie.replace(/(?:(?:^|.*;\s*)username\s*\=\s*([^;]*).*$)|^.*$/, "$1");
  // console.log(cookieValue)
  const fetchPackaiingApi = async () => {
    try {
      const response = await fetch(
        "/api/v1/logistics/orders/status/readyForPacking",
        {
          method: "get",
          headers: new Headers({
            "Content-Type": "application/json",
          }),
        }
      );
      const payload = await response.json();
      setPackagingList(payload);
      if (!response.ok) {
        const payload = await response.text();
        alert(payload);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const fetchPackedApi = async () => {
    try {
      // /api/v1/logistics/orders/item/status/packed/9999
      const response = await fetch("/api/v1/logistics/orders/status/packed", {
        method: "get",
        headers: new Headers({
          "Content-Type": "application/json",
        }),
      });
      const payload = await response.json();
      setPackedList(payload);
      if (!response.ok) {
        const payload = await response.text();
        alert(payload);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const fetchDesksdApi = async () => {
    try {
      const response = await fetch("/api/v1/logistics/desks", {
        method: "get",
        headers: new Headers({
          "Content-Type": "application/json",
        }),
      });
      const payload = await response.json();
      setdesksList(payload);
      // console.log(desksList);
      // console.log(payload);
      if (!response.ok) {
        const payload = await response.text();
        alert(payload);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const PacklisteProblemInvoiceIdHandler = (invoiceID) => {
    setPacklisteProblemInvoiceId(invoiceID);
  };

  const packlisteProblemHandler = async (e) => {
    // e.preventDefault()
    if (packlisteProblemtextareaValue !== null) {
      try {
        const response = await fetch(
          `/api/v1/logistics/orders/item/problem/${packlisteproblemInvoiceId}/`,
          {
            method: "POST",
            headers: new Headers({
              "Content-Type": "application/json",
            }),
            body: JSON.stringify({
              Description: packlisteProblemtextareaValue,
            }),
          }
        );
        // console.log(response);
        if (response.ok) {
          // setUpdateDocTable(!updateDocTable);
          setUpdateTriger(!updateTriger);
          setpacklisteProblemtextareaValue(null);
        }
        if (!response.ok) {
          const payload = await response.text();
          alert("Error " + response.status + "\n" + "request was not successful" + "\n\n" + payload);
        }
      } catch (e) {
        console.log(e);
        alert(e);
      }
    }
  };

  const handlePacklisteTextareaChange = (event) => {
    setpacklisteProblemtextareaValue(event.target.value);
  };

  const bearbeitenHandler = (
    data,
    lNam,
    // fName,
    country,
    orderID,
    IncoiveDIGIT
  ) => {
    // console.log(data);
    // console.log(data.items[0].invoiceId)
    setbearbeitenataForModal(data);
    setCustomerInfo(lNam + " aus " + country + ".");
    setOrderID(orderID);
    // setInvoiceIDTEMPORARY(IncoiveDIGIT)
    setBbId(data._id);
    setInvoiceIdForUPS(data.items[0].invoiceId)
  };

  const printHandler = async (invoiceDigit, type) => {
    try {
      // if (packingdropdownValue === 'select')
      if (cookieValue === "" || cookieValue === null) {
        alert("Bitte zuerst den Druckerplatz auswählen!");
      } else {
        // const response = await fetch(`/api/v1/logistics/orders/item/${invoiceDigit}/print/Printer1/${type}`, {
        const response = await fetch(
          `/api/v1/logistics/orders/item/${invoiceDigit}/print/${cookieValue}/${type}`,
          {
            method: "get",
            headers: new Headers({
              "Content-Type": "application/json",
            }),
          }
        );

        // const payload = await response.json();
        // setRechnungValue(payload)
        // console.log(rechnungValue)
        // console.log(response);
        if (response.ok) {
          // setRechnung(invoiceDigit)
          // setclickType(type)
          // console.log(response)
          setUpdateTriger(!updateTriger);
        }
        if (!response.ok) {
          const payload = await response.text();
          alert(payload);
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  const PackagingPost = async (e) => {
    // e.preventDefault()
    try {
      const response = await fetch(`/api/v1/logistics/orders/status/${bbId}`, {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json",
        }),
        body: JSON.stringify({
          StatusName: "packed",
        }),
      });
      // console.log(response);
      if (response.ok) {
        // setUpdateCheckWatchTable(!updateCheckWatchTable);
        btoggle();
        // PackagingShipedPost()
        setUpdateTriger(!updateTriger);
      }
      if (!response.ok) {
        const payload = await response.text();
        alert(payload);
      }
    } catch (e) {
      console.log(e);
      alert(e);
    }
  };
  // const PackagingShipedPost = async (e) => {
  //     // e.preventDefault()
  //     try {
  //         const response = await fetch(`/api/v1/logistics/orders/status/${bbId}`, {
  //             method: 'POST',
  //             headers: new Headers({
  //                 'Content-Type': 'application/json',
  //             }),
  //             body: JSON.stringify({
  //                 "StatusName": "shipped"
  //             })
  //         });
  //         console.log(response)
  //         if (response.ok) {
  //             // setUpdateCheckWatchTable(!updateCheckWatchTable);
  //             btoggle()
  //             setUpdateTriger(!updateTriger);
  //         }
  //     } catch (e) {
  //         console.log(e);
  //         alert(e);
  //     }
  // }


  const [manualTrackingIdModalOpen, setManualTrackingIdModal] = useState(false);
  const manualTrackingIdToggle = () => setManualTrackingIdModal(!manualTrackingIdModalOpen);

  //const shippingManualTrackingIdHandler = (data) => {
  // }

  const shippingManualTrackingIdHandler = async (data, input, e) => {
    // e.preventDefault()
    try {
      //console.log(input)
      if (input === '') {
        alert("Please fill in the tracking ID")
      } else {
        const response = await fetch(`/api/v1/logistics/orders/carrier/${data._id}`, {
          method: "POST",
          headers: new Headers({
            "Content-Type": "application/json",
          }),
          body: JSON.stringify({
            CarrierName: data.shippingCarrier,
            TrackingId: input
          }),
        });
        // console.log(response);
        if (response.ok) {
          manualTrackingIdToggle();
          setInput('')
          setUpdateTriger(!updateTriger)
          btoggle();
        }
        if (!response.ok) {
          alert("could not submit the tracking ID");
        }
      }
    } catch (e) {
      console.log(e);
      alert(e);
    }
  };

  useEffect(() => {
    fetchPackaiingApi();
    fetchPackedApi();
  }, [updateTriger, packingdropdownValue]);

  useEffect(() => {
    fetchDesksdApi();
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchdocumentsToPrintmanuallyApi = async (inId, what) => {
    try {
      const response = await fetch(
        `/api/v1/logistics/orders/item/${inId}/documents`,
        {
          method: "get",
          headers: new Headers({
            "Content-Type": "application/json",
          }),
        }
      );
      const payload = await response.json();
      // setDocumentList(payload);
      // console.log(documentList);
      //console.log(payload);
      if (what === "certificate") {
        setManualPrint([payload.certificate]);
        MPtoggle();
        // payload.certificate.map((certificate, index) => {
        //   window.open(certificate, "_blank");
        //   console.log(payload.certificate);
        //   return "";
        // });
        // alert(
        //   "Here you can copy & paste the certificate(s) to a new tab:\n" +
        //     payload.certificate.join("\n")
        // );
      }
      if (what === "invoice") {
        setManualPrint([payload.invoice]);
        MPtoggle();
        // payload.invoice.map((invoice, index) => {
        //   window.open(invoice, "_blank");
        //   console.log(payload.invoice.length);
        //   return "";
        // });
        // alert(
        //   "Here you can copy & paste the invoice(s) to a new tab:\n" +
        //     payload.invoice.join("\n")
        // );
      }
      if (what === "versandlabel") {
        setManualPrint([payload.upsLabel]);
        MPtoggle();
        // console.log(inId);
        // window.open(payload.upsLabel, "_blank");
        // alert(
        //   "Here you can copy & paste the versandlabel to a new tab:\n" +
        //     payload.upsLabel
        // );
        }
        if (what === "watchRegister") {
            setManualPrint([payload.watchRegister]);
            MPtoggle();
            // console.log(inId);
            // window.open(payload.upsLabel, "_blank");
            // alert(
            //   "Here you can copy & paste the versandlabel to a new tab:\n" +
            //     payload.upsLabel
            // );
        }
      if (!response.ok) {
        const payload = await response.text();
        alert(payload);
      }
    } catch (e) {
      console.log(e);
    }
  };

  // var myLinks = [
  //   "https://google.com",
  //   "https://www.w3schools.com",
  //   "https://developer.mozilla.org/en-US/docs/Web/API/Window/open",
  // ];

  // function openMultipleLinks(links, e) {
  //   for (var i = 0; i < links.length; i++) {
  //     // e.preventDefault();
  //     window.open(links[i], "_blank");
  //   }
  // }

  useEffect(() => {
    var totalValue=0
    packedList.forEach(element => {
      totalValue +=element.parcelPriceAmount
    });
    setPackedSumUp(totalValue)
    console.log(packedSumUp)
  }, [packedList])
  
  return (
    <div className="container customContainer">
      <Badge className="mb-4" variant="info">
        <h1 className="h3">Packliste</h1>
      </Badge>
      <Row>
        <Col sm="12">
          <div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <p>
                Bereit zum Verpacken: <strong>{packagingList.length}</strong>{" "}
                Aufträge
              </p>
              <div
                className="btnAndNumberContainer"
                style={{ alignItems: "baseline" }}
              >
                <p color="primary">Bitte Druckerplatz auswählen:</p>
                <Dropdown
                  isOpen={packingdropdownOpen}
                  toggle={packingdropdowntoggle}
                  className="ml-2"
                >
                  <DropdownToggle caret>
                    {/* {(packingdropdownValue==='') ? "Dropdown" : packingdropdownValue} */}
                    {cookieValue === "" ? "Select..." : cookieValue}
                  </DropdownToggle>
                  <DropdownMenu right>
                    {desksList.map((desk, index) => {
                      return (
                        <DropdownItem
                          key={index}
                          onClick={() => {
                            setPackingDropdownValue(desk.name);
                            cookieHandler(1);
                          }}
                        >
                          {desk.name}
                        </DropdownItem>
                      );
                    })}

                    {/* <DropdownItem onClick={() => { setPackingDropdownValue("printer1"); cookieHandler(1) }}>1</DropdownItem>
                                        <DropdownItem onClick={() => { setPackingDropdownValue("printer2"); cookieHandler(1) }}>2</DropdownItem>
                                        <DropdownItem onClick={() => { setPackingDropdownValue("printer3"); cookieHandler(1) }}>3</DropdownItem>
                                        <DropdownItem onClick={() => { setPackingDropdownValue("printer4"); cookieHandler(1) }}>4</DropdownItem> */}
                  </DropdownMenu>
                </Dropdown>
              </div>
            </div>

            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Digits</th>
                  <th>Auftrag</th>
                  <th>Bezeichnung</th>
                  <th>Gesamtwert</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {packagingList.map((data, index) => {
                  return (
                    <tr key={index}>
                      <td>
                        {data.items.map((item, index) => {
                          return <p key={index}>{item.statusDbDigit}</p>;
                        })}
                      </td>
                      <td>{data.orderId}</td>
                      <td>
                        {data.items.map((item, index) => {
                          return <p key={index}>{item.saleTitle}</p>;
                        })}
                      </td>
                      <td style={data.parcelPriceAmount >= 30000 ? {color: 'white', backgroundColor: 'red', fontWeight: 'bolder'} : {}}>{data.parcelPriceAmount} €</td>
                      <td>
                        <div
                          className="displayFlex"
                          style={{ justifyContent: "space-around" }}
                        >
                          <div>
                            <Button
                              color="primary"
                              onClick={() => {
                                setDesigredList(packagingList);
                                setBearbeitenType("packliste");
                                bearbeitenHandler(
                                  data,
                                  data.customerInfo.name,
                                  //   data.customerInfo.firstName,
                                  data.customerInfo.country,
                                  data.orderId,
                                  data.invoiceId
                                );
                                btoggle();
                              }}
                            >
                              Bearbeiten
                            </Button>
                          </div>
                          {/* <div>
                                                        <Button color="danger" onClick={() => { PacklisteProblemInvoiceIdHandler(data.invoiceId); toggle3(); }} style={{ marginLeft: '10px' }}>Problem</Button>
                                                    </div> */}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </div>
        </Col>
      </Row>
      {/* Bearbeiten modal */}
      <Modal
        size="lg"
        centered={true}
        isOpen={bmodal}
        toggle={btoggle}
        className={className}
        style={{ maxWidth: "1100px", width: "1100px" }}
      >
        <ModalHeader toggle={btoggle} close={closeBtn} className='w-100'>
          Ausgewählter Auftrag:{" "}
          <strong>Nr. {bearbeitenataForModal.orderId}</strong>
          <br />
          {customerInfo} <strong style={{ display: "inline" }}><Badge color="warning" style={{ fontSize: "100%" }}>{bearbeitenataForModal.saleChannelC24DV ? "C24" : "ZA"}</Badge></strong> <strong style={{ display: "inline" }}><Badge color="info" style={{ fontSize: "100%", fontWeight: '400' }}>Gesamtwert der Sendung: {bearbeitenataForModal.parcelPriceAmount ? bearbeitenataForModal.parcelPriceAmount + ' €' : 'no value found'}</Badge></strong>
        </ModalHeader>
        <ModalBody style={{ maxWidth: "1100px", width: "1100px" }}>
          <Table striped>
            <thead>
              <tr>
                <th>Digits</th>
                <th>Bezeichnung</th>
                <th>Arbeitsschritte</th>
              </tr>
            </thead>
            <tbody>
              {DesigredList.map((item, index) => {
                // {
                //   console.log(DesigredList, "KHODESH");
                // }
                if (item.orderId === orderID) {
                  // bbId2 = item._id
                  return item.items.map((itemInOrder, index) => {
                    invoiceIdMP.current = itemInOrder.invoiceId;
                    return (
                      <tr key={index}>
                        <th scope="row">
                          {itemInOrder.statusDbDigit}
                          <br />
                          <hr></hr>
                          <p className="ellipsisForText">
                            {itemInOrder.saleTitle}
                          </p>
                        </th>
                        <td>
                          <div className="imgsContainer">
                            <img
                              onClick={() => {
                                toggleNested(itemInOrder.watchPhotoPath);
                              }}
                              className="bearbeitImgs"
                              src={itemInOrder.watchPhotoPath}
                              alt="watch"
                            />
                            <img
                              onClick={() => {
                                toggleNested(itemInOrder.boxPhotoPath);
                              }}
                              className="bearbeitImgs"
                              src={itemInOrder.boxPhotoPath}
                              alt="Box"
                            />
                            <Modal
                              size="lg"
                              centered={true}
                              isOpen={nestedModal}
                              toggle={toggleNested}
                            // onClosed={closeAll ? toggle : undefined}
                            >
                              {/* <ModalHeader>Nested Modal title</ModalHeader> */}
                              <ModalBody>
                                <img
                                  className="nestedImage"
                                  src={imageSrc}
                                  alt="Box"
                                />
                              </ModalBody>
                              <ModalFooter>
                                <Button color="primary" onClick={toggleNested}>
                                  Done
                                </Button>{" "}
                                {/* <Button color="secondary" onClick={toggleAll}>All Done</Button> */}
                              </ModalFooter>
                            </Modal>
                          </div>
                        </td>
                        <td className="verticalAlignMiddle">
                          <div className="displayTableCaption">
                            {/* <Button color="warning" className="mr-2">Instruction</Button> */}
                            <div
                              style={{
                                display: "-webkit-inline-flex",
                                alignItems: "center",
                                width: "100%",
                                justifyContent: "flex-end",
                              }}
                            >
                              <Button
                                className="mg8"
                                // style={rechnung === itemInOrder.invoiceId && clickType === "recipt" ? { backgroundColor: 'grey' } : {}}
                                color="primary"
                                onClick={() => {
                                  printHandler(
                                    itemInOrder.invoiceId,
                                    "invoices"
                                  );
                                }}
                              >
                                Rechnung
                              </Button>
                              <div className="verticalLine">
                                <button
                                  className="all"
                                  // onClick={()=>{openMultipleLinks(myLinks)}}
                                  onClick={() => {
                                    fetchdocumentsToPrintmanuallyApi(
                                      itemInOrder.invoiceId,
                                      "invoice"
                                    );
                                  }}
                                  style={{ display: "block", color: "unset" }}
                                >
                                  <i
                                    style={{
                                      fontSize: "xx-large",
                                      display: "inline",
                                      verticalAlign: "middle",
                                      marginLeft: "10px",
                                      cursor: "pointer",
                                    }}
                                    className="far fa-file-pdf"
                                  ></i>
                                </button>
                                {/* {documentList.invoice.map((inv,index) => {
                                  return (
                                    <a href={inv}>MP</a>
                                  )
                                })} */}

                                {/* <a href="\\\\192.168.1.54\\EXPORT\\DOK\\RECHNUNG\\77324_en.pdf" onClick={()=> {alert('copy & paste this link: \\\\192.168.1.54\\EXPORT\\DOK\\RECHNUNG\\77324_en.pdf, \\\\192.168.1.54\\EXPORT\\DOK\\RECHNUNG\\77324_en.pdf, \\\\192.168.1.54\\EXPORT\\DOK\\RECHNUNG\\77324_en.pdf')}}>MP</a> */}
                                {/* <span>\\\\192.168.1.54\\EXPORT\\DOK\\RECHNUNG\\77324_en.pdf</span> */}
                              </div>
                            </div>
                            <div
                              style={{
                                display: "-webkit-inline-flex",
                                alignItems: "center",
                                width: "100%",
                                justifyContent: "flex-end",
                              }}
                            >
                              <Button
                                // style={rechnung === itemInOrder.invoiceId && clickType === "certificate" ? { backgroundColor: 'grey' } : {}}
                                className="mg8"
                                color="primary"
                                onClick={() => {
                                  printHandler(
                                    itemInOrder.invoiceId,
                                    "certificate"
                                  );
                                }}
                              >
                                Zertifikat
                              </Button>
                              <div className="verticalLine">
                                <button
                                  className="all"
                                  // onClick={()=>{
                                  //     window.open('https://www.google.de/','','width=800,height=800');
                                  //     window.open('https://www.yahoo.de/','','width=700,height=700');
                                  // }}
                                  onClick={() => {
                                    fetchdocumentsToPrintmanuallyApi(
                                      itemInOrder.invoiceId,
                                      "certificate"
                                    );
                                  }}
                                  style={{ display: "block", color: "unset" }}
                                >
                                  <i
                                    style={{
                                      fontSize: "xx-large",
                                      display: "inline",
                                      verticalAlign: "middle",
                                      marginLeft: "10px",
                                      cursor: "pointer",
                                    }}
                                    className="far fa-file-pdf"
                                  ></i>
                                </button>
                              </div>
                                    </div>
                            <div
                                style={{
                                    display: "-webkit-inline-flex",
                                    alignItems: "center",
                                    width: "100%",
                                    justifyContent: "flex-end",
                                }}
                            >
                                <Button
                                    // style={rechnung === itemInOrder.invoiceId && clickType === "certificate" ? { backgroundColor: 'grey' } : {}}
                                    className="mg8"
                                    color="primary"
                                    onClick={() => {
                                        printHandler(
                                            itemInOrder.invoiceId,
                                            "watchRegister"
                                        );
                                    }}
                                >
                                    WR Zert.
                                </Button>
                                <div className="verticalLine">
                                    <button
                                        className="all"
                                        onClick={() => {
                                            fetchdocumentsToPrintmanuallyApi(
                                                itemInOrder.invoiceId,
                                                "watchRegister"
                                            );
                                        }}
                                        style={{ display: "block", color: "unset" }}
                                    >
                                        <i
                                            style={{
                                                fontSize: "xx-large",
                                                display: "inline",
                                                verticalAlign: "middle",
                                                marginLeft: "10px",
                                                cursor: "pointer",
                                            }}
                                            className="far fa-file-pdf"
                                        ></i>
                                    </button>
                                </div>
                            </div>
                            <Button
                              // style={rechnung === itemInOrder.invoiceId && clickType === "certificate" ? { backgroundColor: 'grey' } : {}}
                              className="mg8"
                              color="danger"
                              onClick={() => {
                                setpacklisteProblemtextareaValue(null);
                                PacklisteProblemInvoiceIdHandler(
                                  itemInOrder.invoiceId
                                );
                                toggle3();
                                btoggle();
                              }}
                            >
                              Problem
                            </Button>
                          </div>
                        </td>
                      </tr>
                    );
                  });
                }
                return null;
              })}
            </tbody>
          </Table>
          <Modal
            size="lg"
            centered={true}
            isOpen={MPmodal}
            toggle={MPtoggle}
            className={className}
          >
            <ModalHeader toggle={MPtoggle}>Manuelles Drucken</ModalHeader>
            <ModalBody>
              <h6>
                Bitte die Dateipfade nacheinander auswählen, kopieren und in
                einem neuen Tab einfügen.
              </h6>
              <ul>
                {manualPrint.map((MP, index) => {
                  return (
                    <li key={index} style={{ marginBottom: "8px" }}>
                      {MP}
                    </li>
                  );
                })}
              </ul>
            </ModalBody>
            <ModalFooter>
              <Button color="primary" onClick={MPtoggle}>
                OK
              </Button>{" "}
            </ModalFooter>
          </Modal>
        </ModalBody>
        <ModalFooter style={{ justifyContent: "space-between" }}>
          <div style={{ display: "-webkit-inline-flex", alignItems: "center" }}>
            {/*console.log(bearbeitenataForModal)*/}
                      {(bearbeitenataForModal.shippingCarrier === "UPS")
                          || (bearbeitenataForModal.shippingCarrier?.toLowerCase()?.startsWith("dhl express"))
                          || (bearbeitenataForModal.shippingCarrier?.toLowerCase()?.startsWith("dhl paket")) ? (
              <Button
                color="secondary"
                onClick={() => {
                  printHandler(invoiceIdForUPS, "upsLabel");
                }}
              >
                {bearbeitenataForModal.shippingCarrier} Versandlabel
              </Button>
            ) : (
              <p style={{ marginBottom: "0px" }}>
                <b>{bearbeitenataForModal.shippingCarrier}</b>
              </p>
            )}

            <div className="verticalLine" style={{ marginLeft: "10px" }}>
              <button
                className="all"
                // onClick={()=>{openMultipleLinks(myLinks)}}
                onClick={() => {
                  fetchdocumentsToPrintmanuallyApi(
                    invoiceIdMP.current,
                    "versandlabel"
                  );
                }}
                style={{ display: "block", color: "unset" }}
              >
                <i
                  style={{
                    fontSize: "xx-large",
                    display: "inline",
                    verticalAlign: "middle",
                    marginLeft: "10px",
                    cursor: "pointer",
                  }}
                  className="far fa-file-pdf"
                ></i>
              </button>
            </div>
            <div className="verticalLine" style={{ marginLeft: "10px" }}>
              <button
                className="all"
                onClick={() => { setInput(bearbeitenataForModal.carrierTrackingId ? bearbeitenataForModal.carrierTrackingId : ''); manualTrackingIdToggle() }}
                style={{ display: "block", color: "unset" }}
              >
                <i
                  style={{
                    fontSize: "xx-large",
                    display: "inline",
                    verticalAlign: "middle",
                    marginLeft: "10px",
                    cursor: "pointer",
                  }}
                  className="far fa-keyboard"
                ></i>
              </button>
            </div>
            <Modal centered={true} isOpen={manualTrackingIdModalOpen} toggle={manualTrackingIdToggle}
            //onClosed={this.state.closeAll ? this.toggle : undefined}
            >
              <ModalHeader toggle={manualTrackingIdToggle}>Manual Tracking ID</ModalHeader>
              <ModalBody>
                <p>
                  Please write and submit the Tracking ID of the order
                </p>
                <InputGroup>
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>{bearbeitenataForModal.shippingCarrier}</InputGroupText>
                  </InputGroupAddon>
                  <Input value={input} onChange={e => setInput(e.target.value)} />
                  <InputGroupAddon addonType="append">
                    <Button onClick={() => {
                      shippingManualTrackingIdHandler(
                        bearbeitenataForModal, input
                      );
                    }} color="primary">Submit</Button></InputGroupAddon>
                </InputGroup>
              </ModalBody>
              <ModalFooter>
                <Button style={{ width: '100%' }} color="secondary" onClick={manualTrackingIdToggle}>Cancel</Button>{' '}
              </ModalFooter>
            </Modal>
          </div>
          <Button
            color="primary"
            style={{ width: "350px" }}
            onClick={() => {
              printHandler(invoiceIdMP.current, "all");
            }}
          >
            Alles Drucken
          </Button>{" "}
          {/* {!(DesigredList === packedList) &&  */}
          {BearbeitenType === "packliste" && (
            <Button
              color="success"
              onClick={() => {
                PackagingPost();
              }}
            // onClick={btoggle}
            >
              Auftrag fertiggestellt
            </Button>
          )}
          {/* } */}
          {/* {console.log("desigered:", DesigredList)} */}
        </ModalFooter>
      </Modal>
      {/* problem modal */}
      <Modal
        isOpen={modal3}
        size="lg"
        centered={true}
        toggle={toggle3}
        className={className}
      >
        <ModalHeader toggle={toggle3}>Problem melden</ModalHeader>
        <ModalBody>
          <textarea
            style={{ width: "100%", height: "100px" }}
            onChange={handlePacklisteTextareaChange}
          ></textarea>
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={() => {
              packlisteProblemHandler();
              toggle3();
            }}
          >
            Problem speichern
          </Button>{" "}
          {/* <Button color="primary" onClick={() => {packlisteProblemHandler(); toggle3();}}>Store the comment</Button>{' '} */}
          <Button color="secondary" onClick={toggle3}>
            Abbrechen
          </Button>
        </ModalFooter>
      </Modal>
      <hr className="hrDivider"></hr>
      <Problems
        page="packing"
        update={updateTriger}
        parentStateChanger={setUpdateTriger}
      />
      <hr className="hrDivider"></hr>
      <Badge className="mb-4" variant="info">
        <h1 className="h3">Fertig verpackt</h1>
      </Badge>
      <div>
        <p>
          Verpackt: <strong>{packedList.length}</strong> Aufträge 
          <strong style={{ display: "inline", marginLeft: '16px' }}><Badge color={packedSumUp >= 250000 ? 'danger' : "info" } style={{ fontSize: "100%", fontWeight: '500' }}>Gesamtwert der Sendungen: {packedSumUp ? packedSumUp + ' €' : 'no value found'}</Badge></strong>
        </p>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Auftrag</th>
              <th>Digits</th>
              <th>Bezeichnung</th>
              <th>Gesamtwert</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {packedList.map((data, index) => {
              // console.log(packedList, "injaaaaaaaaaaaa");
              //setPackedSumUp( packedSumUp + parseInt(data.parcelPriceAmount))
              return (
                <tr key={index}
                  style={{
                    backgroundColor: "#00FA9A	",
                    color: "#212529",
                    opacity: "0.8",
                  }}
                >
                  <td>{data.orderId}</td>
                  <td>
                    {data.items.map((item, index) => {
                      return <p key={index}>{item.statusDbDigit}</p>;
                    })}
                  </td>
                  <td>
                    {data.items.map((item, index) => {
                      return <p key={index}>{item.saleTitle}</p>;
                    })}
                  </td>
                  <td style={data.parcelPriceAmount >= 30000 ? {color: 'white', backgroundColor: 'red', fontWeight: 'bolder'} : {}}>{data.parcelPriceAmount} €</td>
                  <td>
                    <Button
                      key={index}
                      color="primary"
                      onClick={() => {
                        setDesigredList(packedList);
                        setBearbeitenType("verpackt");
                        bearbeitenHandler(
                          data,
                          data.customerInfo.name,
                          //   data.customerInfo.firstName,
                          data.customerInfo.country,
                          data.orderId,
                          data.invoiceId
                        );
                        btoggle();
                      }}
                    >
                      Bearbeiten
                    </Button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    </div>
  );
}
